module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/girls-4b8c3b3f7ac48ad2d36dc04e64d55fd9.webp";